import { PaginationResponse } from "src/models/BaseModel";
import { Transaction } from "src/models/TransactionModel";
import { PrivateApi } from "./BaseApi";

type GetDashBoardTransactionsBody = {
  endpoint: string;
  pageNumber: number;
  pageSize: number;
  filter?: string | null;
};

export const transactionsApi = PrivateApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardTransactions: builder.query<
      PaginationResponse<Transaction[]>,
      any
    >({
      query: (body: GetDashBoardTransactionsBody) => ({
        url: body.endpoint,
        method: "POST",
        body,
      }),
      providesTags: ["Transactions"],
    }),
    CancelTranscation: builder.mutation({
      query: ({ orderId, reason }: { orderId: string; reason: string }) => ({
        url: "Dashboard/CancelTransaction",
        method: "POST",
        body: {
          data: {
            orderId,
            reason,
          },
        },
      }),
      invalidatesTags: ["Transactions"],
      transformResponse: (response: any) => {
        return response.result;
      },
    }),
  }),
});

export const {
  useGetDashboardTransactionsQuery,
  useLazyGetDashboardTransactionsQuery,
  useCancelTranscationMutation,
} = transactionsApi;
